import React, { Fragment, useEffect } from 'react'
import { notification } from 'antd'

import useInterval from '../elements/Hooks/useInterval'

function UpdateDetector() {
  useInterval(() => {
    if (window['isUpdateAvailable']) {
      notification.info({
        key: 'UPDATE',
        message: 'NEW UPDATE',
        duration: 0,
        description: (
          <span>
            New content is available. Please update PMS by clicking
            <a onClick={() => window.location.reload(true)}> Here</a>
          </span>
        ),
      })
    }
  }, 500)
  return <Fragment />
}

UpdateDetector.propTypes = {}
UpdateDetector.defaultProps = {}

export default (UpdateDetector)
